import { NgModule } from 'ng-metadata/core';
import { FormAddressComponent } from './address.component';
import './address.scss';

@NgModule({
  declarations: [
    FormAddressComponent,
  ],
})
export class FormAddressModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/address/address.module.ts